"use client";

import { AppImages } from "@/constants";
import { cn } from "@/shared/core/utils";
import Image from "next/image";
import { Spinner } from "./spinner";

interface LoadingWithLogoProps {
  isFullScreen?: boolean;
  message?: string;
  className?: string;
}

/**
 * Loading component with Agarea logo animation
 * Replicates the old project's LoadingWithLogo component
 */
export function LoadingWithLogo({
  isFullScreen = true,
  message,
  className,
}: LoadingWithLogoProps) {
  const content = (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-4",
        className
      )}
    >
      {/* Logo with pulse animation */}
      <div className="relative">
        <div className="h-16 w-16 animate-pulse">
          <Image
            src={AppImages.kPngLogo}
            alt="Agarea Logo"
            width={64}
            height={64}
            className="h-16 w-16"
            priority
          />
        </div>
      </div>

      {/* Loading spinner */}
      <Spinner size="lg" />

      {/* Optional message */}
      {message && <p className="text-sm text-muted-foreground">{message}</p>}
    </div>
  );

  if (isFullScreen) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-background/80 backdrop-blur-sm">
        {content}
      </div>
    );
  }

  return content;
}

export default LoadingWithLogo;
